// src/functions/uploadDocument.js
import { getFunctions, httpsCallable } from "firebase/functions";

const functions = getFunctions();

export const uploadDocument = async (
  fileType,
  file,
  company,
  collectionBrand,
  systemName,
  uniqueId,
  fileName
) => {
  try {
    // Validate file
    if (!(file instanceof File)) {
      console.error("Invalid file:", { fileName, type: typeof file });
      throw new Error("File must be a valid File object");
    }

    // Check file size (limit to ~7MB to stay under 10MB base64 limit)
    if (file.size > 7 * 1024 * 1024) {
      console.error("File too large:", { fileName, size: file.size });
      throw new Error("File size exceeds 7MB limit");
    }

    // Convert file to base64
    const fileReader = new FileReader();
    const fileBuffer = await new Promise((resolve, reject) => {
      fileReader.onload = () => resolve(fileReader.result.split(",")[1]);
      fileReader.onerror = () => reject(new Error("Failed to read file"));
      fileReader.readAsDataURL(file);
    });

    console.log("Uploading document:", {
      company,
      collectionBrand,
      systemName,
      uniqueId,
      fileName,
      bufferLength: fileBuffer.length,
    });

    // Call Cloud Function
    const uploadCandidateDocument = httpsCallable(
      functions,
      "uploadCandidateDocument"
    );
    const response = await uploadCandidateDocument({
      auth: true,
      company,
      collectionBrand,
      systemName,
      uniqueId,
      fileName,
      fileBuffer,
      fileType,
    });

    const { success, url, storagePath } = response.data;
    if (!success) {
      console.error("Upload failed:", { fileName, response: response.data });
      throw new Error(
        response.data.message || `Failed to upload document ${fileName}`
      );
    }

    console.log("Document uploaded successfully:", {
      fileName,
      url,
      storagePath,
    });
    return url; // Return download URL to match original function signature
  } catch (error) {
    console.error("Error uploading document:", {
      fileName,
      message: error.message,
      stack: error.stack,
    });
    throw error; // Propagate error to trigger uploadError state
  }
};
